import { connect } from 'react-redux';
import MultiSelectButton from './MultiSelectButton';

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiSelectButton);



// WEBPACK FOOTER //
// ./src/containers/MultiSelectButton/index.js